// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"808":"4de5b866","912":"dec3d7e6"}[chunkId] + ".chunk.js";
};